function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ZimbabweFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_3562_2686",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_3562_2686)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_3562_2686",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_3562_2686)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 4.5V19.5H24V4.5H0Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0 9.625H-0.875V10.5V13.5V14.375H0H24H24.875V13.5V10.5V9.625H24H0Z",
        fill: "#272727",
        stroke: "#E31D1C",
        strokeWidth: "1.75"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 6V3H24V6H0ZM0 21V18H24V21H0Z",
        fill: "#5EAA22"
      })]
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.298481 2.59886L-0.5 2.00472V3V21V21.9805L0.293611 21.4047L12.5421 12.5187L13.0929 12.1191L12.5469 11.7128L0.298481 2.59886Z",
      fill: "#F7FCFF",
      stroke: "#272727"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_3562_2686",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "-1",
      y: "1",
      width: "15",
      height: "22",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0.298481 2.59886L-0.5 2.00472V3V21V21.9805L0.293611 21.4047L12.5421 12.5187L13.0929 12.1191L12.5469 11.7128L0.298481 2.59886Z",
        fill: "white",
        stroke: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask2_3562_2686)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.60881 13.7087L2.7746 15.9965L4.07463 12.9391L1.84082 10.7879H4.47753L5.55946 8.19378L6.7086 10.7879H9.34082L6.98901 12.9391L8.16602 15.9965L5.60881 13.7087Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.76316 9.31613C3.76316 9.31613 3.72202 9.21693 3.96488 9.12923C4.20775 9.04152 4.28184 8.85568 4.47222 8.99246C4.6626 9.12923 4.78171 8.85425 4.83633 9.24865C4.89096 9.64305 5.04152 10.265 5.04152 10.265L7.5072 12.118H7.04394C7.04394 12.118 6.32255 13.1778 6.44166 14.1078C6.44166 14.1078 5.94393 14.0321 5.2693 14.0321C4.59466 14.0321 4.1528 14.1938 4.1528 14.1938L3.76316 12.751C3.76316 12.751 3.90424 12.5086 3.96488 12.3133C4.02553 12.118 4.27664 12.0819 4.27664 11.9265C4.27664 11.7711 4.02895 11.6408 4.1528 11.2386C4.27664 10.8363 4.27664 9.63304 4.27664 9.63304C4.27664 9.63304 3.88523 9.46092 3.96488 9.46092C4.04453 9.46092 4.2261 9.31613 4.09549 9.31613C3.96488 9.31613 3.76316 9.31613 3.76316 9.31613Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Zimbabwe.js.map